import React from 'react';
import { Check, CheckCheck } from 'lucide-react';
import { cn } from '../../lib/utils';

interface MessageBubbleProps {
  content: string;
  timestamp: string;
  isOwn: boolean;
  senderName?: string;
  isRead?: boolean;
}

export function MessageBubble({
  content,
  timestamp,
  isOwn,
  senderName,
  isRead,
}: MessageBubbleProps) {
  const formatTime = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div
      className={cn(
        'flex w-full mb-3',
        isOwn ? 'justify-end' : 'justify-start'
      )}
    >
      <div
        className={cn(
          'max-w-[75%] rounded-2xl px-4 py-2.5 shadow-sm',
          isOwn
            ? 'bg-[#FF9F68] text-white rounded-br-md'
            : 'bg-white border border-gray-200 text-gray-900 rounded-bl-md'
        )}
      >
        {!isOwn && senderName && (
          <p className="text-xs font-medium text-[#FF9F68] mb-1">
            {senderName}
          </p>
        )}
        <p className="text-sm whitespace-pre-wrap leading-relaxed">{content}</p>
        <div
          className={cn(
            'flex items-center gap-1 mt-1',
            isOwn ? 'justify-end' : 'justify-start'
          )}
        >
          <span
            className={cn(
              'text-[10px]',
              isOwn ? 'text-orange-100' : 'text-gray-400'
            )}
          >
            {formatTime(timestamp)}
          </span>
          {isOwn && (
            <span className="text-orange-100">
              {isRead ? (
                <CheckCheck className="h-3 w-3" />
              ) : (
                <Check className="h-3 w-3" />
              )}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}

export default MessageBubble;

